ACC.product = {

    _autoload: [
        'bindToAddToCartForm',
        'enableStorePickupButton',
        'enableVariantSelectors',
        'bindFacets',
        'focusPriceAndOrderingOnBtnClick',
        'programTabsClick',
        'filterAccordionClick',
        'bindDisplayAttributeInfo',
        'bindSharePopup',
        'displayNeedHelpPopup',
        'needHelpPrintOnly',
        'relatedItemsPrint',
        'displayCallToActionPopup',
        'closeModal',
        'insertIframe',
    ],

    closeModal() {
        $('#colorbox').on('click', '.js-mini-cart-close-button', $modal.close);
    },

    bindFacets() {
        // Open Facets modal
        $('.js-show-facets').on('click', function () {
            $modal.open(this);
            $('#cboxLoadedContent').find('.accordion-panel-show').removeClass('accordion-panel-show');
        });

        // Enable toggling of open facets in modal.
        // This is necessary so the toggles work within the dynamically loaded content into modals.
        $('.js-product-facet .js-facet-name').on('click', function () {
            if ($(this).parent().hasClass('active') && $(this).closest('#cboxLoadedContent').length) {
                $(this).parent().removeClass('active');
                $(this).closest('#product-facet').find('.active').removeClass('active')
                    .find('.facet-data')
                    .toggleClass('toggled');
                $(this).next().hide().removeClass('accordion-panel-show')
                    .css('opacity', '0');
            } else if ($(this).closest('#cboxLoadedContent').length > 0) {
                $(this).parent().addClass('active');
                $(this).find('.facet-data').addClass('toggled');
                $(this).next().show().css('opacity', '1')
                    .addClass('accordion-panel-show');
            }
        });
    },

    enableAddToCartButton() {
        $('.js-enable-btn').each(function () {
            if (!($(this).hasClass('outOfStock') || $(this).hasClass('out-of-stock'))) {
                $(this).prop('disabled', false);
            }
        });
    },

    enableVariantSelectors() {
        $('.variant-select').prop('disabled', false);
    },

    bindToAddToCartForm() {
        $('.add_to_cart_form').ajaxForm({
            success: ACC.product.updateCartOnSuccess,
        });
    },

    bindToAddToCartStorePickUpForm() {
        const addToCartStorePickUpForm = $('#colorbox #add_to_cart_storepickup_form');
        addToCartStorePickUpForm.ajaxForm({
            success: ACC.product.displayAddToCartPopup,
        });
    },

    enableStorePickupButton() {
        $('.js-pickup-in-store-button').prop('disabled', false);
    },

    updateCartOnSuccess(cartResult, statusText, xhr, formElement) {
        if (xhr.status === 200 && xhr.responseText) {
            ACC.product.updateCartStatus(cartResult, formElement);
            ACC.product.displayAddToCartPopup(cartResult, formElement);
        }
    },

    updateCartStatus(cartResult, formElement) {
        ACC.minicart.updateMiniCartDisplay(cartResult.cartData.totalCartItemsCount);
        $(document).trigger('analytics_updateCart', cartResult, formElement);
    },

    displayAddToCartPopup(cartResult, formElement) {
        $modal.open(null, {
            html: cartResult.addToCartLayer,
            title: formElement.find('.js-add-to-cart').attr('data-modal-title'),
        });
    },

    focusPriceAndOrderingOnBtnClick() {
        $('#pricing-tab-btn').click(() => {
            $('html, body').stop().animate({
                scrollTop: $('.tabs-list').offset().top,
            }, 1000);
            $('#pricing-ordering').click();
        });
    },

    programTabsClick(bindOnly) {
        $(document).ready(() => {
            const tabsLiASelector = 'ul.tabs-list li a';
            let currentTabContent;
            $(tabsLiASelector).click(function (e) {
                // Prevent a tag from opening link
                e.preventDefault();
                $(this).parent().find('li:hidden').show();
                // Save tab ID link
                const tabId = $(this).data('tab-id');

                if ($(this).parent().hasClass('moretab')) {
                    $(this).parent().addClass('active');
                    if (!bindOnly) {
                        // eslint-disable-next-line no-undef
                        calcWidth(true);
                    }
                    return;
                }
                currentTabContent = $(`#${tabId}`);

                const aemContentTabContainer = currentTabContent.find('#aemContentTabContainer');
                if ($(this).parent().parent().hasClass('tabpopup')) {
                    // De-select all the tabs
                    $(tabsLiASelector).removeClass('current-tab');
                    $('.tab-content').removeClass('current-tab-content');
                    $(tabsLiASelector).attr('aria-selected', 'false');

                    // Select this tab
                    $(this).addClass('current-tab');
                    currentTabContent.addClass('current-tab-content');
                    $(this).attr('aria-selected', 'true');
                    $('.tabpopup').css('display', 'none');
                    $('.moretab').removeClass('active');
                    if (aemContentTabContainer.length > 0) {
                        ACC.product.pullAemTabContent();
                    }
                    // skipping calculation for more items to avoid PMCCP-4481 issue
                    if (!bindOnly) {
                        // eslint-disable-next-line no-undef
                        calcWidth(true);
                    }
                } else {
                    // De-select all the tabs
                    $('.current-tab').removeClass('current-tab');
                    $('.tab-content').removeClass('current-tab-content');
                    $(tabsLiASelector).attr('aria-selected', 'false');
                    $('.moretab a:first').text('More...');

                    // Select this tab
                    $(this).addClass('current-tab');
                    currentTabContent.addClass('current-tab-content');
                    $(this).attr('aria-selected', 'true');
                    if (aemContentTabContainer.length > 0) {
                        ACC.product.pullAemTabContent();
                    }
                    if (!bindOnly) {
                        // eslint-disable-next-line no-undef
                        calcWidth();
                    }
                }
            });
        });
    },

    filterAccordionClick() {
        $(document).ready(() => {
            $('.js-accordion').click(function () {
                const filterContent = $(this).next();
                $(filterContent).toggle();
            });
        });
    },

    pullAemTabContent() {
        const aemContentTabContainer = $('#aemContentTabContainer');
        if (aemContentTabContainer.length > 0) {
            $.get(aemContentTabContainer.data('aemurl'), (data) => {
                // eslint-disable-next-line no-undef
                aemContentTabContainer.html(DOMPurify.sanitize(data));

                if (data.length > 0) {
                    // eslint-disable-next-line no-inner-declarations
                    function reformatDate(dateBlock) {
                        const startDate = new Date($($(dateBlock.find('ul > li')[0]).find('time')[0]).attr('datetime'));
                        const endDate = new Date($($(dateBlock.find('ul > li')[1]).find('time')[0]).attr('datetime'));
                        const noDateError = (startDate <= endDate);
                        let newDateBlock;
                        let newTimeBlock;

                        // Setting time and zone data
                        const startTime = $($(dateBlock.find('ul > li')[0]).find('time')[1]).attr('datetime');
                        const endTime = $($(dateBlock.find('ul > li')[1]).find('time')[1]).attr('datetime');
                        const displaytime = $($(dateBlock.find('ul > li')[2]).find('time')[0]).attr('display');
                        const timezone = $($(dateBlock.find('ul > li')[2]).find('time')[0]).attr('zone');

                        if ((endDate.getFullYear() > startDate.getFullYear()) && noDateError) {
                            // Spans end of year
                            newDateBlock = `<time datetime="${
                                startDate
                            }"><span>${
                                // eslint-disable-next-line max-len
                                startDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
                            }&ndash;</span></time><time datetime="${
                                endDate
                            }"><span>${
                                endDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
                            }</span></time>`;
                        } else if ((endDate.getMonth() > startDate.getMonth()) && noDateError) {
                            // Spans end of month
                            newDateBlock = `<time datetime="${
                                startDate
                            }"><span>${
                                startDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' })
                            }&ndash;</span></time><time datetime="${
                                endDate
                            }"><span>${
                                endDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
                            }</span></time>`;
                        } else if ((endDate.getDate() > startDate.getDate()) && noDateError) {
                            // Spans end of day
                            newDateBlock = `<time datetime="${
                                startDate
                            }"><span>${
                                startDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' })
                            }&ndash;</span></time><time datetime="${
                                endDate
                            }"><span>${
                                endDate.toLocaleDateString('en-US', { day: 'numeric' })
                            }, ${
                                endDate.toLocaleDateString('en-US', { year: 'numeric' })
                            }</span></time>`;
                        } else {
                            // Single day
                            newDateBlock = `<time datetime="${
                                startDate
                            }"><span>${
                                // eslint-disable-next-line max-len
                                startDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
                            }</span></time>`;

                            if (displaytime) {
                                newTimeBlock = `${'<div class="event-clock">'
                                // eslint-disable-next-line max-len
                                + '<time><span class="weight--default typecase-lower" >'}${startTime.replace('AM', 'a.m.').replace('PM', 'p.m.')
                                } &#8211; ${
                                    endTime.replace('AM', 'a.m.').replace('PM', 'p.m.')
                                }&nbsp;</span><span class="weight--default">${timezone}</span></time></div>`;
                            }
                        }

                        if (!displaytime) {
                            dateBlock
                                .find('ul')
                                .replaceWith(newDateBlock);
                        } else {
                            dateBlock
                                .find('ul')
                                .replaceWith(newDateBlock)
                                .end()
                                .after(newTimeBlock);
                        }
                    }

                    (function eventListing() {
                        const eventList = $('.event-list');
                        if (eventList.length > 0) {
                            if ($('.event-list-live-online').length > 0) {
                                const liveOnlineHTML = $('.event-list-live-online').html().trim();
                                $('.event-list-live-online').html(liveOnlineHTML);
                            }

                            if ($('.event-list-in-person').length > 0) {
                                const inPersonHTML = $('.event-list-in-person').html().trim();
                                $('.event-list-in-person').html(inPersonHTML);
                            }

                            const eventSublist = eventList.find('ul, ol');

                            if (eventSublist.length === 0) {
                                eventList.addClass('empty-list');
                            }
                        }

                        // Reformat date display
                        eventList.find('.event-list-container').each(function () {
                            const eachListContainer = $(this);

                            if ($(eachListContainer).find('.event-list-properties').length > 0) {
                                $(eachListContainer).find('.event-list-time').css('display', 'none');
                                $(eachListContainer).find('.event-list-address').css('display', 'none');
                            } else {
                                const eachListTime = ($(this).find('.event-list-time'));
                                reformatDate(eachListTime);
                            }
                        });
                    }());

                    aemContentTabContainer.addClass('is-visible');
                }
            });
        }
    },

    displayNeedHelpPopup() {
        $(document).ready(() => {
            $('#help-link').click(function (e) {
                e.preventDefault();
                $(this).attr('data-modal-title', ACC.needHelpPopupTitle);
                $(this).attr('data-modal-content', $('.supportContent').html());
                $modal.open(this);
            });
        });
    },

    displayCallToActionPopup() {
        $(document).ready(() => {
            $('.js-callToActionModal').on('click', function (e) {
                e.preventDefault();
                // Get next element content ( for this modal )
                const content = $(this).next().html();
                // and assign it as data attribute so modal can
                // pick them up and use it.
                $(this).attr('data-modal-content', content);
                // Trigger modal
                $modal.open(this);
            });
        });
    },

    needHelpPrintOnly() {
        $(document).ready(() => {
            if ($('body').hasClass('page-programDetails')) {
                const needHelpPrintHeadline = ACC.needHelpPopupTitle;
                // eslint-disable-next-line no-undef
                const content = DOMPurify.sanitize($('.supportContent').html());

                const printHelp = [
                    '<div class="needHelpPrintCont print-only">',
                    `<h4>${needHelpPrintHeadline}</h4>`,
                    content,
                    '</div>',
                ].join('\n');

                $('.magic-box__container').append(printHelp);
            }
        });
    },

    relatedItemsPrint() {
        $(document).ready(() => {
            if ($('body').hasClass('page-programDetails')) {
                const relatedList = $('<ul class="link-list print-only" />');

                $('.carousel--related').find('.carouselItem__name').each(function () {
                    relatedList.append(`<li>${$(this).text()}</li>`);
                });

                $('.carousel--related').append(relatedList);
            }
        });
    },

    bindDisplayAttributeInfo() {
        $('.js-display-attribute-info').on('click', function () {
            $modal.open(this);
        });
    },

    showTabsPanel() {
        const tabsWrapper = document.querySelector('.tabs-wrapper');
        if (!tabsWrapper) return;

        ACC.product.emptyTab(tabsWrapper);
        // Don't show tabs if we don't have content.
        if (tabsWrapper.style.display !== 'block' && tabsWrapper.querySelectorAll('.tab-content').length) {
            tabsWrapper.style.display = 'block';
            ACC.product.addTabActiveClass(tabsWrapper);
            // eslint-disable-next-line no-undef
            calcWidth();
        }
    },

    emptyTab(tabsWrapper) {
        const tabContent = Array.prototype.slice.call(tabsWrapper.querySelectorAll('.tab-content'));
        // Remove empty tab
        tabContent.forEach((element) => {
            if (!element.querySelector('.tab-content__inner').innerText.trim().length) {
                const { id } = element;
                const tabTitle = tabsWrapper.querySelectorAll(`a[data-tab-id=${id}]`)[0];

                tabTitle.parentElement.remove();
                element.remove();
            }
        });
    },

    addTabActiveClass(tabsWrapper) {
        const tabContent = tabsWrapper.querySelectorAll('.tab-content');
        // Active class for tab content
        tabContent[0].classList.add('current-tab-content');
        // Active class for tab title
        tabsWrapper.querySelectorAll('a[data-tab-id]')[0].classList.add('current-tab');
    },

    bindSharePopup() {
        $('.magic-box').on('click', '.modal-trigger__social-share', function () {
            $modal.open(this);
        });

        function highlight(el) {
            el.addClass('highlight');
            setTimeout(() => {
                el.removeClass('highlight');
            }, 2000);
        }

        $(document).on('click', '#copy-share-link', () => {
            const copyPasteInput = $('input#copyInput');
            copyPasteInput.select();
            document.execCommand('copy');
            highlight(copyPasteInput);
        });
    },

    pricingOrderingAutoExpand() {
        if ($('#pricing-ordering-content')) {
            const poContainer = $('#pricing-ordering-content > .tab-content__inner');
            const pricingGrid = $('#pricing-ordering-content');
            const fp = pricingGrid.find('.pricing-grid__list-price').first();
            const fpComponent = fp.closest('.accordion__component');
            const fpParent = fpComponent.parent('.accordion__content');
            const fpParentPrevHeader = fpParent.prev('.accordion__header');
            const triggerOne = fpComponent.find('.accordion__trigger');
            const triggerTwo = fpParentPrevHeader.find('.accordion__trigger');
            // eslint-disable-next-line max-len
            const triggerThree = fpParentPrevHeader.parents('.accordion__content').prev('.accordion__header').find('.accordion__trigger');

            triggerOne
                .add(triggerTwo)
                .add(triggerThree);

            // DOM changes complete; reveal container
            poContainer.addClass('is-visible');
        }
    },

    insertIframe() {
        const iframeContainer = document.querySelector('#pdp-video__container');

        if (iframeContainer) {
            const nameEl = iframeContainer.querySelector('.prototype-video__youtube__name');
            const srcEl = iframeContainer.querySelector('.prototype-video__youtube__src');

            const iframe = document.createElement('iframe');

            iframe.setAttribute('title', nameEl.innerHTML);
            iframe.setAttribute('src', srcEl.innerHTML);
            iframe.setAttribute('width', '560');
            iframe.setAttribute('height', '315');
            iframe.setAttribute('frameBorder', '0');
            iframe.setAttribute('allow', 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;');
            iframe.classList.add('pdp-youtube-video');

            iframeContainer.appendChild(iframe);
        }
    },
};

$(document).ready(() => {
    // $ajaxCallEvent = true;
    ACC.product.enableAddToCartButton();
    ACC.product.showTabsPanel();
    ACC.product.pricingOrderingAutoExpand();
});
